import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FinalCta() {
  const revealRef = useScrollReveal();
  return <section className="relative bg-brand-violetDark py-10 px-[5%] overflow-hidden" data-id="element-35">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.15)_0%,_transparent_60%)] pointer-events-none" data-id="element-36" />

      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 text-center reveal" data-id="element-37">
        <h2 className="font-display italic font-light text-[52px] text-brand-cream/90 max-w-[700px] mx-auto leading-[1.2] mb-8" data-id="element-38">
          "No busques la luz.
          <br data-id="element-39" />
          Sé la luz que colapsa la oscuridad
          <br data-id="element-40" />
          en nuevas galaxias de posibilidad."
        </h2>

        <div className="w-[60px] h-[1px] bg-brand-gold mx-auto mb-6" data-id="element-41" />

        <p className="font-body font-light text-[17px] text-brand-cream/55 mb-12" data-id="element-42">
          Tu nueva identidad ya existe en el campo.
          <br data-id="element-43" />
          Solo falta que la elijas.
        </p>

        <a href="#producto" className="inline-block bg-brand-gold text-brand-dark font-body text-[15px] font-medium py-4 px-9 rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_8px_28px_rgba(201,169,110,0.35)]" data-id="element-44">
          COMENZAR MI PROCESO DE RENACER — $6.39 &rarr;
        </a>

        <div className="flex flex-wrap justify-center gap-6 mt-7" data-id="element-45">
          {['Precio de lanzamiento', 'Descarga inmediata', 'Garantía 7 días', 'Pago 100% seguro'].map((trust, i) => <div key={i} className="font-body text-[13px] text-brand-cream/35" data-id="element-46">
              ✦ {trust}
            </div>)}
        </div>
      </div>
    </section>;
}